/* eslint-disable jsx-a11y/no-autofocus,react/require-default-props,react/prop-types */
import React from 'react';
import PropTypes from 'prop-types';
import CSSModules from 'react-css-modules';

import Icon from '../../Icon';
import ActionButton from '../../common/ActionButton';

import { COLORS } from '../../../constants/styles';
import { COMMUNUNNITY_NEW_POST } from '../../../constants/strings';
import styles from './index.styl';

const UrlInput = ({ onCancel, onUrl, formatMessage }) => (
  <div styleName="url-input">
    <input
      autoFocus
      onChange={e => onUrl(e.target.value)}
      placeholder={formatMessage(COMMUNUNNITY_NEW_POST.enterUrl)}
      type="text"
      styleName="input"
    />
    <div styleName="icon-close">
      <ActionButton onClick={onCancel}>
        <Icon name="close" size={24} style={{ fill: COLORS.white }} />
      </ActionButton>
    </div>
  </div>
);

UrlInput.propTypes = {
  onCancel: PropTypes.func,
  onUrl: PropTypes.func,
};

export default CSSModules(UrlInput, styles);



// WEBPACK FOOTER //
// ./src/components/Community/NewPost/UrlInput.jsx